/**
 * Pure helper functions extracted from calculator_controller.js
 */

export const DEFAULT_CONSTANTS = {
  naftaPricePerLiter: 78.02,
  homeChargeKwh: 2.40,
  publicChargeKwh: 7.56,
  exchangeRate: 39.07,
  evAnnualService: 3000,
  evInsuranceAnnual: 25000,
}

export const DEFAULT_EV = {
  id: 'seagull-300',
  name: 'BYD Seagull 300',
  year: 2026,
  priceUSD: 19990,
  efficiency: 15,
  patenteUYU: 15364,
}

export const DEFAULT_DATA = {
  ev: DEFAULT_EV,
  gasPrice: 25000,
  gasConsumption: 12,
  gasPatente: 15000,
  gasInsurance: 30000,
  serviceKm: 10000,
  serviceCost: 8000,
  period: 5,
  annualKm: 15000,
  homeChargePercent: 80,
}

export function formatNumber(num) {
  return Math.round(num).toLocaleString('es-UY')
}

export function calculateTCO(data, constants) {
  const { ev, gasPrice, gasConsumption, gasPatente, gasInsurance, serviceKm, serviceCost, period, annualKm, homeChargePercent } = data
  const c = constants

  // Gas car annual costs
  const safeGasConsumption = gasConsumption || 1 // guard against division by zero
  const safeServiceKm = serviceKm || 1
  const gasAnnualFuel = (annualKm / safeGasConsumption) * c.naftaPricePerLiter
  const gasAnnualService = (annualKm / safeServiceKm) * serviceCost
  const gasAnnualTotal = gasAnnualFuel + gasPatente + gasInsurance + gasAnnualService

  // EV annual costs
  const evEnergyConsumption = annualKm * (ev.efficiency / 100)
  const homeChargeRatio = homeChargePercent / 100
  const publicChargeRatio = 1 - homeChargeRatio
  const evAnnualEnergy = evEnergyConsumption * (homeChargeRatio * c.homeChargeKwh + publicChargeRatio * c.publicChargeKwh)
  const evAnnualTotal = evAnnualEnergy + ev.patenteUYU + c.evInsuranceAnnual + c.evAnnualService

  // Total costs over period
  const gasPurchasePrice = gasPrice * c.exchangeRate
  const evPurchasePrice = ev.priceUSD * c.exchangeRate

  const gasTotalOperating = gasAnnualTotal * period
  const evTotalOperating = evAnnualTotal * period

  const gasTotalCost = gasPurchasePrice + gasTotalOperating
  const evTotalCost = evPurchasePrice + evTotalOperating

  // Savings
  const totalSavings = gasTotalCost - evTotalCost
  const operatingSavings = gasTotalOperating - evTotalOperating
  const monthlySavings = (gasAnnualTotal - evAnnualTotal) / 12

  // Breakeven calculation
  const priceDifference = evPurchasePrice - gasPurchasePrice
  const annualOperatingSavings = gasAnnualTotal - evAnnualTotal
  const breakevenYears = annualOperatingSavings > 0 ? priceDifference / annualOperatingSavings : null

  // Annual breakdown
  const annualBreakdown = []
  for (let year = 1; year <= period; year++) {
    annualBreakdown.push({
      year,
      evCost: evAnnualTotal,
      gasCost: gasAnnualTotal,
      savings: gasAnnualTotal - evAnnualTotal
    })
  }

  return {
    ev,
    period,
    annualKm,
    gasPurchasePrice,
    evPurchasePrice,
    gasAnnualTotal,
    evAnnualTotal,
    gasTotalOperating,
    evTotalOperating,
    gasTotalCost,
    evTotalCost,
    totalSavings,
    operatingSavings,
    monthlySavings,
    breakevenYears,
    annualBreakdown,
    exchangeRate: c.exchangeRate
  }
}
